export default __webpack_public_path__ + "static/media/cinemaLogo.b781885c.jpg";